interface IconButtonProps {
  icon: string;
  onClick: () => void;
  disabled?: boolean;
  alt?: string;
  className?: string;
}

export const IconButton = ({ icon, alt, onClick, disabled, className }: IconButtonProps) => {
  return (
    <div className={`${disabled ? 'pointer-events-none' : 'cursor-pointer'} p-1`} onClick={onClick}>
      <img src={icon} alt={alt} className={`${className} h-9`} />
    </div>
  );
};
